module.exports = __webpack_public_path__ + "static/media/vip-hour-tile-1.39b20a4f.png";